import { useQuery } from "react-query";
import { firestore } from "@/services/firestore";
import { CustomerUpdate } from "@/types/v2";

interface UseCustomerUpdatesByCardIdParams {
  shopId: string;
  cardId: string;
  enabled?: boolean;
}

export const useCustomerUpdatesByCardId = ({
  shopId,
  cardId,
  enabled = true,
}: UseCustomerUpdatesByCardIdParams) => {
  return useQuery({
    queryKey: ["customerUpdates-by-cardId", shopId, cardId],
    queryFn: async (): Promise<CustomerUpdate[]> => {
      if (!shopId || !cardId) {
        return [];
      }

      // Query for all customer updates with the specific cardId, ordered by updatedAt descending
      const result =
        await firestore.paginateDocumentsWithFilters<CustomerUpdate>(
          `/shops/${shopId}/customerUpdates`,
          100, // Get up to 100 customer updates (should be enough for most cards)
          undefined, // No cursor needed since we want all results
          undefined, // No converter
          "updatedAt", // Sort by updatedAt as requested
          "desc", // Descending order to get newest first
          [
            {
              searchParam: "cardId",
              opsString: "==",
              equality: cardId,
            },
          ]
        );

      return result.docs as CustomerUpdate[];
    },
    enabled: enabled && !!shopId && !!cardId,
    staleTime: 5 * 1000, // Cache for 5 seconds
    cacheTime: 20 * 1000, // Keep in cache for 20 seconds
  });
};
